<section class="child-form-group">
  <form id="sublease-request-form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate class="astral-sublease-form">
    <div class="astral-form-stack">
      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
        <div class="astral-layout-item">
          <astral-date-picker
            [control]="form.controls['fromDate']"
            [model]="subleaseRequest.fromDate"
            [isRequired]="true"
            [label]="'SUBLEASE_REQUEST.FROMDATE'"
            [helpText]="'SUBLEASE_REQUEST.HELP_TEXT.FROM_DATE'"
          ></astral-date-picker>
        </div>
        <div class="astral-layout-item">
          <astral-date-picker
            [control]="form.controls['toDate']"
            [model]="subleaseRequest.toDate"
            [isRequired]="true"
            [label]="'SUBLEASE_REQUEST.TO_DATE'"
            [helpText]="'SUBLEASE_REQUEST.HELP_TEXT.TO_DATE'"
          ></astral-date-picker>
        </div>
      </astral-layout-group>

      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
        <astral-input [control]="form.controls['subleaseeName']"></astral-input>
        <astral-input [control]="form.controls['subleaseeEmail']" [type]="'email'" [inputMode]="'email'"></astral-input>
        <astral-input [control]="form.controls['subleaseePhone']"></astral-input>
        <astral-input class="astral-grid-full" [control]="form.controls['reason']"></astral-input>
      </astral-layout-group>

      <div class="astral-form-actions">
        <astral-button type="submit" labelKey="OK_BTN"></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      </div>
    </div>
  </form>
</section>
